import { __assign, __spreadArray, __read } from 'tslib';
import { useDatePickerContext } from '../DatePickerContext/DatePickerContext.js';
import isBefore from '../../node_modules/date-fns/esm/isBefore/index.js';
import startOfDay from '../../node_modules/date-fns/esm/startOfDay/index.js';
import isAfter from '../../node_modules/date-fns/esm/isAfter/index.js';
import endOfDay from '../../node_modules/date-fns/esm/endOfDay/index.js';
import startOfYear from '../../node_modules/date-fns/esm/startOfYear/index.js';
import lastDayOfYear from '../../node_modules/date-fns/esm/lastDayOfYear/index.js';
import isSameMonth from '../../node_modules/date-fns/esm/isSameMonth/index.js';
import isSameDay from '../../node_modules/date-fns/esm/isSameDay/index.js';
import max from '../../node_modules/date-fns/esm/max/index.js';
import min from '../../node_modules/date-fns/esm/min/index.js';
import isWithinInterval from '../../node_modules/date-fns/esm/isWithinInterval/index.js';
import getDate from '../../node_modules/date-fns/esm/getDate/index.js';
import getMonth from '../../node_modules/date-fns/esm/getMonth/index.js';
import addDays from '../../node_modules/date-fns/esm/addDays/index.js';
import subDays from '../../node_modules/date-fns/esm/subDays/index.js';

var getValue = function (_a) {
    var value = _a.value, hoverDate = _a.hoverDate, focusDate = _a.focusDate, isHover = _a.isHover, showRange = _a.showRange;
    var singleValue = Array.isArray(value) ? undefined : value;
    var multiNetValue = Array.isArray(value) ? __spreadArray([], __read(value), false) : undefined;
    var multiValue = multiNetValue && __spreadArray([], __read(multiNetValue), false);
    if (showRange && Array.isArray(value) && value.length === 1) {
        if (isHover) {
            hoverDate && (multiValue === null || multiValue === void 0 ? void 0 : multiValue.push(hoverDate));
        }
        else {
            focusDate && (multiValue === null || multiValue === void 0 ? void 0 : multiValue.push(focusDate));
        }
    }
    return { singleValue: singleValue, multiNetValue: multiNetValue, multiValue: multiValue };
};
var getDateProps = function (_a) {
    var date = _a.date, inMonth = _a.inMonth, focusDate = _a.focusDate, value = _a.value, startYear = _a.startYear, endYear = _a.endYear, disabledBefore = _a.disabledBefore, disabledAfter = _a.disabledAfter, showRange = _a.showRange, mode = _a.mode, readonly = _a.readonly, disabled = _a.disabled, isHover = _a.isHover, hoverDate = _a.hoverDate;
    var _b = getValue({
        value: value,
        hoverDate: hoverDate,
        focusDate: focusDate,
        isHover: isHover,
        showRange: showRange,
    }), singleValue = _b.singleValue, multiNetValue = _b.multiNetValue, multiValue = _b.multiValue;
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ readonly: readonly, disabled: disabled }, (disabledBefore &&
        isBefore(date, startOfDay(disabledBefore)) && {
        disabled: true,
    })), (disabledAfter &&
        isAfter(date, endOfDay(disabledAfter)) && {
        disabled: true,
    })), (startYear &&
        isBefore(date, startOfYear(startYear)) && {
        disabled: true,
    })), (endYear &&
        isAfter(date, lastDayOfYear(endYear)) && {
        disabled: true,
    })), (inMonth &&
        !isSameMonth(date, inMonth) && {
        isDifferentMonth: true,
    })), (focusDate &&
        !disabled &&
        !readonly &&
        mode === "month" &&
        isSameDay(date, focusDate) && { isFocus: true, tabIndex: 0 })), (singleValue && isSameDay(date, singleValue) && { selected: true })), (multiNetValue &&
        (multiNetValue === null || multiNetValue === void 0 ? void 0 : multiNetValue.filter(function (d) { return isSameDay(date, d); }).length) > 0 && {
        selected: true,
    })), (showRange &&
        multiValue &&
        !isSameDay(min(multiValue), max(multiValue)) &&
        isSameDay(date, min(multiValue)) && {
        isRangeStart: true,
    })), (showRange &&
        multiValue &&
        !isSameDay(min(multiValue), max(multiValue)) &&
        isSameDay(date, max(multiValue)) && {
        isRangeEnd: true,
    })), (showRange &&
        multiValue &&
        multiValue.length > 1 &&
        !isSameDay(min(multiValue), max(multiValue)) &&
        isWithinInterval(date, {
            start: min(multiValue),
            end: max(multiValue),
        }) && {
        isRangeBetween: true,
    }));
};
var useDateKeyDownHandler = function (_a) {
    var navigateDate = _a.navigateDate, selectDate = _a.selectDate, date = _a.date, setIsHover = _a.setIsHover;
    return function (e) {
        var keyNavigateDate = function (d) {
            navigateDate(d);
            setIsHover(false);
        };
        switch (e.code) {
            case "ArrowLeft":
                e.preventDefault();
                keyNavigateDate(subDays(date, 1));
                break;
            case "ArrowRight":
                e.preventDefault();
                keyNavigateDate(addDays(date, 1));
                break;
            case "ArrowUp":
                e.preventDefault();
                keyNavigateDate(subDays(date, 7));
                break;
            case "ArrowDown":
                e.preventDefault();
                keyNavigateDate(addDays(date, 7));
                break;
            case "Enter":
            case "Space":
                e.preventDefault();
                selectDate(date);
                break;
        }
    };
};
var useDatePickerDate = function (_a) {
    var date = _a.date, inMonth = _a.inMonth;
    var context = useDatePickerContext();
    var navigateDate = context.navigateDate, selectDate = context.selectDate, datesRef = context.datesRef, focusDateRef = context.focusDateRef, focusDate = context.focusDate, size = context.size, setIsHover = context.setIsHover, setHoverDate = context.setHoverDate, checkIsDisabled = context.checkIsDisabled, checkIsInFocusMonths = context.checkIsInFocusMonths;
    var dateProps = getDateProps(__assign({ date: date, inMonth: inMonth }, context));
    var d = getDate(date);
    var m = getMonth(date);
    var dateKeyDownHandler = useDateKeyDownHandler({
        navigateDate: navigateDate,
        selectDate: selectDate,
        date: date,
        setIsHover: setIsHover,
    });
    var dateClickHandler = function (e) {
        e.preventDefault();
        if (checkIsInFocusMonths(date))
            selectDate(date);
    };
    var dateHoverHandler = function () {
        if (!checkIsDisabled(date) && checkIsInFocusMonths(date)) {
            setIsHover(true);
            setHoverDate(date);
        }
    };
    var dateMouseLeaveHandler = function () {
        setHoverDate(undefined);
    };
    return {
        props: __assign(__assign({}, dateProps), { size: size, title: date.toDateString(), ref: function (element) {
                !dateProps.isDifferentMonth &&
                    element &&
                    (datesRef.current[m][d] = element);
                focusDateRef &&
                    isSameDay(focusDate, date) &&
                    (focusDateRef.current = element);
            }, onKeyDown: dateKeyDownHandler, onClick: dateClickHandler, onMouseEnter: dateHoverHandler, onMouseLeave: dateMouseLeaveHandler, children: d }),
    };
};

export { useDatePickerDate };
//# sourceMappingURL=useDatePickerDate.js.map
